import React from "react";

const Terms = () => (
  <div className="max-w-4xl mx-auto px-4 py-10 text-gray-200">
    <h1 className="text-3xl font-bold mb-6 text-red-600">Terms of Service</h1>
    <p>By using CineCue, you agree to comply with our terms and conditions outlined below:</p>

    <h2 className="text-2xl font-semibold mt-6 mb-2">Use of Service</h2>
    <ul className="list-disc ml-6 mb-4">
      <li>Access CineCue for personal, non-commercial use only.</li>
      <li>Do not attempt to distribute or modify our content illegally.</li>
      <li>Respect copyright laws for all streamed movies and shows.</li>
    </ul>

    <h2 className="text-2xl font-semibold mt-6 mb-2">Account Responsibility</h2>
    <p>Users are responsible for maintaining the confidentiality of their account credentials and activity under their account.</p>
  </div>
);

export default Terms;
